"use client"

import { SlidersHorizontal } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SlidersHorizontalIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SlidersHorizontalIcon = component(Icon)({ as: SlidersHorizontal })
